import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';

const SectionGuard = ({ slug, children }) => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/listing-sections`)
      .then(res => {
        if (cancelled) return;
        const sections = res.data.sections || [];
        const found = sections.find(s => s.slug === slug);
        setStatus(found ? 'active' : 'inactive');
      })
      .catch(() => {
        if (!cancelled) setStatus('active'); // fail-open
      });
    return () => { cancelled = true; };
  }, [slug]);

  if (status === 'loading') return null;
  if (status === 'inactive') return <Navigate to="/" replace />;
  return children;
};

export default SectionGuard;
